const faqData = [
  {
    q: '香蕉影视需要注册登录才能使用吗？',
    a: '完全不需要！香蕉影视始终坚持「打开即看」的理念，所有剧集资源无需注册、无需登录、无需付费即可免费观看。我们致力于消除一切追剧障碍，让每一位用户都能轻松享受追剧的乐趣。',
  },
  {
    q: '播放时为什么会卡顿？如何解决？',
    a: '香蕉影视采用先进的CDN全球加速技术，正常情况下1080P视频可实现秒开流畅播放。如果遇到卡顿，建议您：1）检查当前网络连接是否稳定；2）尝试切换清晰度至720P；3）关闭其他占用带宽的应用；4）刷新页面重试。绝大部分卡顿问题都可以通过以上方式解决。',
  },
  {
    q: '手机上看和电脑上看有什么区别？',
    a: '香蕉影视完美适配手机、平板和电脑三大终端，无论您使用哪种设备，都能获得一致的高清观剧体验。手机端页面经过专门优化，触控操作更便捷；电脑端支持大屏超清播放，画质更震撼。两个平台的剧集资源完全同步，追剧进度无缝衔接。',
  },
  {
    q: '新剧上线后多久能在平台上看到？',
    a: '我们的内容更新团队7×24小时不间断工作，热门剧集通常在电视台播出后2-4小时内即可在香蕉影视同步上线。部分海外剧集因翻译和字幕制作需要，可能会延迟6-12小时。我们承诺以最快的速度将最新剧集呈现给每一位用户。',
  },
];

export default function Faq() {
  return (
    <section id="faq" className="py-14 md:py-20 bg-background-50">
      <div className="max-w-3xl mx-auto px-4 md:px-6">
        <div className="text-center mb-10 md:mb-14">
          <h2 className="font-heading text-2xl md:text-3xl text-foreground-950 mb-3">常见问题</h2>
          <p className="text-foreground-500 text-sm max-w-lg mx-auto">关于香蕉影视的常见疑问，这里都能找到答案</p>
        </div>

        <div className="space-y-3">
          {faqData.map((item, i) => (
            <div key={i} className="rounded-xl bg-background-100 border border-background-200/70 p-5">
              <h3 className="font-heading text-base text-foreground-900 mb-2 flex items-start gap-2">
                <span className="text-primary-500 flex-shrink-0 mt-0.5">
                  <i className="ri-question-line"></i>
                </span>
                {item.q}
              </h3>
              <p className="text-foreground-600 text-sm leading-relaxed pl-6">{item.a}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}